import Skeleton from "react-loading-skeleton"

const CreatePlaceSkt = () => {
    return (
        <div className="tw-flex tw-flex-col tw-gap-2">
            <Skeleton className="tw-w-20 tw-p-1" />
            <Skeleton className="tw-w-full tw-h-[350px] tw-rounded-lg" />
        </div>
    )
}

export default CreatePlaceSkt